const footerLinks = [
  {
    url: 'https://arsenikrecords.bandcamp.com/',
    name: 'Bandcamp',
  },
  {
    url: 'https://www.discogs.com/label/902545-Arsenik-Records',
    name: 'Discogs',
  },
  {
    url: 'https://soundcloud.com/arsenik_rec',
    name: 'Soundcloud',
  },
];

export const Footer = () => {
  return (
    <footer className="px-8 h-[15vh] flex justify-end items-center text-default gap-12">
      {footerLinks.map((link) => (
        <a
          key={link.url}
          href={link.url}
          target="_blank"
          className="underline hover:no-underline"
        >
          {link.name}
        </a>
      ))}
    </footer>
  );
};
